import { CreditCardOutlined, PaidOutlined, ManageAccountsOutlined, VideocamOutlined } from '@mui/icons-material';
import { useL10n } from '@uplift/hooks';
import { HelpCenterContainer, HelpCenterTile } from '@uplift/pages';
import { UpliftThemeProvider } from '@uplift/ui-v2';
import { MainLayout } from '../../components';

const PATIENT_TILES: HelpCenterTile[] = [
  {
    title: 'When will my card on file be charged?',
    description: 'Understand when charges appear on your card.',
    icon: CreditCardOutlined,
    href: 'https://client-help.joinuplift.co/en_us/when-will-my-card-on-file-be-charged-SyV_ZETuJx',
  },
  {
    title: 'How much will I pay for sessions?',
    description: 'Learn what you\'ll owe per session and what insurance covers.',
    icon: PaidOutlined,
    href: 'https://client-help.joinuplift.co/en_us/how-much-will-i-pay-for-sessions-ByRVzVTOJl',
  },
  {
    title: 'How do I change my provider?',
    description: 'Request a new provider match from your dashboard.',
    icon: ManageAccountsOutlined,
    href: 'https://client-help.joinuplift.co/en_us/how-do-i-change-my-provider-H17UFjgdke',
  },
  {
    title: 'I\'m having trouble joining my session.',
    description: 'Troubleshoot common video session issues.',
    icon: VideocamOutlined,
    href: 'https://client-help.joinuplift.co/en_us/i-m-having-trouble-joining-my-session-what-should-i-do-Byxo6E6uyx',
  },
];

const PATIENT_HELP_CENTER_URL = 'https://client-help.joinuplift.co';

export const SupportPage = () => {
  const l10n = useL10n();

  return (
    <MainLayout>
      <UpliftThemeProvider>
        <HelpCenterContainer
          tiles={PATIENT_TILES}
          helpCenterUrl={PATIENT_HELP_CENTER_URL}
          title={l10n.support.pageTitle}
          subtitle={l10n.support.pageSubtitle}
        />
      </UpliftThemeProvider>
    </MainLayout>
  );
};
